import { makeStyles } from '@material-ui/core'

/**
 * ONE column constant, shared by the header, the row and the skeleton.
 *
 * portal-ux-conventions §2 asks for this explicitly so the three cannot drift.
 * The ChannelsList reference repeats its ratio literal in two places, which is
 * the thing the rule exists to prevent, so it is not copied here.
 */
export const COLUMNS = '5fr 5fr 5fr 6fr 7fr 7fr 7fr 8fr'

const cell = {
  // Grid children default to min-width:auto, so one long unbreakable token — a
  // channel id, an untranslated code — sets the column's floor and shoves every
  // other column aside. min-width:0 lets the track keep its fr share and the
  // break happens inside the cell rather than outside it.
  minWidth: 0,
  overflowWrap: 'anywhere' as const
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  tableHead: {
    '& > div': { ...cell },
    width: '100%',
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: theme.spacing(1, 1.5),
    gap: theme.spacing(1)
  },
  row: {
    '& > div': { ...cell },
    width: '100%',
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    alignItems: 'center',
    padding: theme.spacing(1, 1.5),
    gap: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
    '&:hover': { backgroundColor: theme.palette.action.hover }
  },
  // The whole point of the screen is scanning a grid, so a row carrying a
  // finding must be findable without reading every assessment cell.
  rowFlagged: {
    borderLeft: `3px solid ${theme.palette.error.main}`
  },
  rowNormal: {
    borderLeft: '3px solid transparent'
  },
  findingChip: {
    cursor: 'help',
    display: 'block'
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(6, 2)
  },
  emptyImage: {
    maxWidth: 180,
    opacity: 0.8
  }
}))

export default useStyles
